export default __webpack_public_path__ + "static/media/pic1.2b7d6618.png";